<template>
    <div class="tc-ui-container">
        <Notifications/>
        <TheGuide v-show="storeUI.isGuide"/>
        <DraggedItem/>
        <div class="tc-configurator-layout">
            <TheLeftSidebar/>
            <div class="tc-configurator-workspace-overlay">
                <div class="tc-workspace-instruments-container">
                    <TopInstrumentsMenu/>
                </div>
                <LowerHelpers/>
            </div>
            <div class="tc-configurator-right-sidebar">
                <RightSidebarItems/>
                <RightSidebarSummary/>
            </div>
        </div>
    </div>
</template>

<script>
import TopInstrumentsMenu from '@/UI/Workspace/TopInstrumentsMenu.vue';
import RightSidebarSummary from '@/UI/RightSidebar/RightSidebarSummary.vue';
import TheLeftSidebar from '@/UI/LeftSidebar/TheLeftSidebar.vue';
import RightSidebarItems from '@/UI/RightSidebar/RightSidebarItems.vue';
import LowerHelpers from '@/UI/Workspace/LowerHelpers.vue';
import Notifications from '@/UI/Workspace/Notifications.vue';
import DraggedItem from '@/UI/Workspace/DraggedItem.vue';
import { $ } from '@/Engine/state';
import { clearFromParent, storeConfigurationUpdate } from '@/Engine/app';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { parseConfigStringToJSON, parseToolChestStringToJSON } from '@/libs/parseQueryConfig';
import { casesLib } from '@/Constants/casesLib';
import TheGuide from '@/UI/TheGuide.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreMeta } from '@/Store/storeMeta';
import { getProjectByUrlParams } from '@/libs/getProject';
import { updateImagesOnConfigurationChange } from '@/libs/updateImagesOnConfigurationChange';
import { computeProjectCost } from '@/libs/calcConfigurationCost';
export default {
    name: 'TheConfigurator',
    components: {
        TheGuide,
      DraggedItem,
        Notifications,
        LowerHelpers,
        RightSidebarItems,
        TheLeftSidebar,
        RightSidebarSummary,
        TopInstrumentsMenu,
    },
    setup() {
      const storeCaseConfiguration = useStoreCaseConfiguration();
      const storeProjectStructure = useStoreProjectStructure();
      const storeUI = useStoreUI();

      return {
          storeCaseConfiguration,
          storeProjectStructure,
          storeUI,
      };
    },
    methods: {
      async parseQueryConfig() {
        const dataInCaseItems = this.$route.query?.config;
        const dataInToolChest = this.$route.query?.toolChest;

        if (!dataInCaseItems && !dataInToolChest) {
          return;
        }

        let dataOutCaseItems = parseConfigStringToJSON(dataInCaseItems);
        let dataOutToolChest = parseToolChestStringToJSON(dataInToolChest);
        const actualToolChest = casesLib.find(x => x.id === dataOutToolChest.blenderName);

        // this.storeCaseConfiguration.resetStoreConfiguration();
        this.storeCaseConfiguration.$patch({
          caseItems: dataOutCaseItems,
          blenderName: dataOutToolChest.blenderName,
          selectedCaseModel: actualToolChest?.key,
          colorFrame: dataOutToolChest.colorFrame,
          colorFace: dataOutToolChest.colorFace,
          isCloseDoors: dataOutToolChest.isCloseDoors,
          drawerSeparators: dataOutToolChest.drawerSeparators,
          expandedDrawersPrototypeId: dataOutToolChest.expandedDrawersPrototypeId,
        });

        console.log('patched by URL config', this.storeCaseConfiguration.$state);

        const newCaseId = crypto.randomUUID();
        // this.storeProjectStructure.clear();
        this.storeProjectStructure.addCase(
            {
              id: newCaseId,
              name: 'Новый шкаф',
              image: '',
              date: Date().toString(),
              cost: 0,
              count: 1,
            },
        );
        this.storeProjectStructure.setSelectedCaseId(newCaseId);
        computeProjectCost();
      },
    },
    async mounted() {
        console.log(useStoreMeta().projectId, this.storeProjectStructure.projectId);
        if (useStoreMeta().projectId && this.storeProjectStructure.projectId !== useStoreMeta().projectId) {
            await getProjectByUrlParams();
        } else {
            if (!this.storeProjectStructure.cases.length) {
              await this.parseQueryConfig();
            }
        }

      //сигнал инициализации
      $.initConfigurator = true;
      await storeConfigurationUpdate(this.storeCaseConfiguration.$state);
      setTimeout(()=>{
        updateImagesOnConfigurationChange();
      }, 300);
    },
    beforeUnmount() {
      //очищаем сцену всю + опускаем флаг
      $.initConfigurator = false;
      $.app?.scene?.children.forEach(child => {
        // $.app.scene?.remove(child);
        child.removeFromParent();
      });

      $?.app?.scene?.traverse(child => {
          if (child.geometry) {
            child.geometry.dispose();
          }
        if (child.material) {
          if (Array.isArray(child.material)) {
            child.material.forEach(mat => {
              mat.dispose();
            });
          } else {
            child.material.dispose();
          }
        }
      });
      clearFromParent();
    },
};
</script>

<style scoped lang="scss">
.tc-ui-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-family: Montserrat, sans-serif;
    overflow: hidden;
    position: absolute;
    z-index: 10;
    pointer-events: none;

    //background-color: #FFB6C140;
}

.tc-configurator-layout {
    padding: 15px;
    display: grid;
    grid-template-columns: max-content auto max-content;
    box-sizing: border-box;
    height: 100%;
}

.tc-configurator-workspace-overlay {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 15px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.tc-workspace-instruments-container {
    width: 100%;
    height: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
}

.tc-configurator-right-sidebar {
    height: 100%;
    width: 320px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    overflow: hidden;
    //padding: 4px;
    //box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
</style>
